import { createFileRoute } from "@tanstack/react-router";
import { SettingsPageShell } from "@/features/settings";

function BillingSettingsPage() {
  return (
    <SettingsPageShell title="Billing" description="Plan and billing controls are coming soon." />
  );
}

export const Route = createFileRoute("/settings/billing")({
  component: BillingSettingsPage,
});
